module.exports = __webpack_public_path__ + "static/eyebrows1-bca2d759463b31a87409c9ff6f104572.jpg";